<template>
  <div class="container-fluid py-3 px-4">

    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-envelope-paper display-4 me-2 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            TECNOLOGIA
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO DE CORREOS
          </p>
        </div>
      </div>
    </div>
    <!-- Card Filtros -->
    <div class="card border border-1 rounded-3 p-3 mb-2">
      <div class="card-body">
        <div class="row gx-3">

          <!-- ID Trabajador -->
          <div class="col-lg-4 col-md-6 col-12 mb-3">
            <label class="form-label tamaño">ID TRABAJADOR:</label>
            <select required v-model="idDelTrabajador" class="form-select text-secondary p-1">
              <option disabled selected value="">-- SELECCIONAR TRABAJADOR --</option>
              <option v-for="trabajador in movIdTrabajadores" :key="trabajador.id" :value="trabajador.idTrabajador">
                {{ trabajador.nombre }}
              </option>
            </select>
          </div>

          <!-- Correo -->
          <div class="col-lg-4 col-md-6 col-12 mb-3">
            <label class="form-label tamaño">CORREO:</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-envelope"></i>
              </span>

              <input v-model="correo" required type="text" class="form-control p-1 text-secondary"
                placeholder="Ingrese correo" @input="correo = correo.replace(/\s+/g, '')" />
            </div>

          </div>

          <!-- Contraseña -->
          <div class="col-lg-4 col-md-6 col-12 mb-3">
            <label class="form-label tamaño">CONTRASEÑA:</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-key"></i></span>
              <input v-model="contraseña" required type="text" class="form-control p-1 text-secondary"
                placeholder="Ingrese contraseña" @input="contraseña = contraseña.replace(/\s+/g, '')" />
            </div>
          </div>

          <!-- Botones -->
          <div class="col-12 mt-2">
            <button class="boton-estiloCuadrado" @click="editar == 'editar' ? ActualizarCorreo() : InsertarCorreo()"
              :class="editar == 'editar' ? 'btn btn-warning' : 'btn btn-success'" title="Guardar correo">
              <i :class="editar == 'editar' ? 'bi bi-pencil' : 'bi bi-floppy'"></i>
            </button>

            <button class="btn btn-primary mx-2 boton-estiloCuadrado"
              @click="(editar = ''), (correo = ''), (contraseña = ''), (idDelTrabajador = '')"
              title="Actualizar correo">
              <i class="bi bi-brush"></i>
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Card Tabla -->
    <div class="card border border-1 rounded-3 p-3 mb-2">
      <div class="card-body">

        <!-- Buscador -->
        <div class="row mb-3 justify-content-end">
          <div class="d-flex justify-content-end">
            <span class="input-group-text mt-2 buscar-estiloCuadrado">
              <i class="bi bi-search"></i>
            </span>

            <input class="form-control form-control-lg w-25 mt-2 me-2 buscar-estiloCuadrado" type="text"
              placeholder="CORREO" v-model="busqueda" @input="busqueda = busqueda.replace(/\s+/g, ''); filtro()"
              @keydown.space.prevent />
          </div>

        </div>

        <!-- Tabla -->
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead class="reducirTamaño">
              <tr class="bg-solimano text-white text-center text-nowrap">
                <th v-for="col in tabla" :key="col.key">{{ col.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(post, index) in tecnoPaginadas" :key="index.id"
                class="text-center align-middle reducirTamaño text-nowrap">
                <!-- Botón Editar -->
                <td>
                  <button class="btn btn-outline-success boton-estiloCuadrado"
                    @click="(editar = 'editar'), (correo = post.correo), (contraseña = post.contrasena), (idDelTrabajador = post.idTrabajador)"
                    title="Editar Correo">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </td>

                <td class="text-center">
                  <i class="bi bi-person-badge me-1"></i>
                  {{ post.idTrabajador }}
                </td>
                <td class="text-start"><i class="bi bi-buildings me-1"></i>{{ post.empresa }}</td>
                <td class="text-start"><i class="bi bi-diagram-3 me-1"></i>{{ post.subCentroCosto }}</td>
                <td class="text-start">
                  <i class="bi bi-diagram-2 me-1"></i>
                  {{ post.subsubCentroCosto }}
                </td>
                <td class="text-start">
                  <i class="bi bi-credit-card-2-front me-1"></i>
                  {{ post.nroDocumento }}
                </td>
                <td class="text-start">
                  <i class="bi bi-person-circle me-1"></i>
                  {{ post.nombre }}
                </td>
                <td class="text-start">
                  <i class="bi bi-briefcase me-1"></i>
                  {{ post.cargo }}
                </td>
                <td class="text-start">
                  <i class="bi bi-calendar-check text-success"></i>
                  {{ post.fec_Inicio }}
                </td>
                <td class="text-start">
                  <i class="bi bi-envelope-paper me-1" style="color:#0dcaf0"></i>
                  {{ post.correo }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!-- Paginación -->
    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
        <i class="bi bi-chevron-double-left"></i>
      </button>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>

      <span class="pagination-info small">Página {{ currentPage }} de {{ totalPages }}</span>

      <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
        :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>

  </div>
</template>


<script>
import Swal from "sweetalert2";
//import { mapActions, mapGetters } from "vuex";
export default {
  name: "CopiasTecnologia",

  data() {
    return {
      idTrabajador: "",
      empresa: "",
      subCentroCosto: "",
      subsubCentroCosto: "",
      nroDocumento: "",
      nombre: "",
      cargo: "",
      fec_Inicio: "",
      correo: "",
      currentPage: 1,
      itemsPerPage: 10,
      busqueda: "",
      editar: "",
      contraseña: "",
      idDelTrabajador: "",
      movIdTrabajadores: [],
      informacion: [],
      idUsuario: "",
      NUM_RESULTS: 9,

      tabla: [
        { key: "id_acciones", label: "ACCIONES" },
        { key: "id_trabajador", label: "ID_TRABAJADOR" },
        { key: "empresa", label: "EMPRESA" },
        { key: "sub_centro_costos", label: "SUB CENTRO DE COSTOS" },
        { key: "sub_sub_centro_costos", label: "SUB SUB CENTRO DE COSTOS" },
        { key: "nro_documento", label: "NRO DOCUMENTO" },
        { key: "nombre", label: "NOMBRE" },
        { key: "cargo", label: "CARGO" },
        { key: "fecha_inicio", label: "FECHA INICIO" },
        { key: "correo", label: "CORREO" },
      ],
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.getAttributes();
  },

  computed: {
    TecnoFiltradas() {
      if (!this.busqueda) return this.informacion;

      const texto = this.busqueda.toLowerCase();

      return this.informacion.filter((d) =>
        String(d.correo).toLowerCase().includes(texto)
      );
    },
    tecnoPaginadas() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.TecnoFiltradas.slice(start, start + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.TecnoFiltradas.length / this.itemsPerPage);
    },
  },

  created() {
    this.cambiarEstadoNavbar();
    this.axios.get(`Tecnologia/ObtenerTrabajadoresMovimiento`).then((r) => {
      this.movIdTrabajadores = r.data;
    });
  },

  methods: {
    getAttributes() {
      this.axios.get(`Tecnologia/ListadoCorreos`).then((r) => {
        console.log(r.data);
        this.informacion = r.data;
      });
    },

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    filtro() {
      this.currentPage = 1;
    },

    ActualizarCorreo() {
      console.log(this.correo, this.editar);
      const from = {
        idTrabajador: this.idDelTrabajador,
        correo: this.correo,
        idUsuario: this.idUsuario,
        CorreoContraseña: this.contraseña,
      };
      console.log(from);
      this.axios.put(`Tecnologia/EditarCorreo`, from).then((r) => {
        console.log(r.data);

        if (r.data.success) {
          Swal.fire(`${r.data.respuesta}`, "Correo editado correctamente", "success");
          this.idDelTrabajador = "";
          this.correo = "";
          this.contraseña = "";
          this.getAttributes();
        }
      });
    },

    InsertarCorreo() {
      const from = {
        idTrabajador: this.idDelTrabajador,
        correo: this.correo,
        idUsuario: this.idUsuario,
        CorreoContraseña: this.contraseña,
      };
      console.log(from);
      this.axios.post(`Tecnologia/InsertarCorreo`, from).then((r) => {
        console.log(r.data);
        if (r.data.success) {
          Swal.fire(`${r.data.respuesta}`, "", "success");
          this.idDelTrabajador = "";
          this.correo = "";
          this.contraseña = "";
          this.getAttributes();
        }
      });
    },
  },
};
</script>

<style scoped>
.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>
